// extracted by mini-css-extract-plugin
export var grid = "h_8";
export var moreButton = "h_7";
export var name = "h_bb";
export var picture = "h_9";
export var quote = "h_s";
export var text = "h_bc";
export var wrapper = "h_6";